import NextQueryParamProvider from './NextQueryParamProvider';
import ReactAriaOverlayProvider from './ReactAriaOverlayProvider';
import ReactQueryProvider from './ReactQueryProvider';

const ModalProvider = dynamic(() => import('./ModalProvider').then(module => module.ModalProvider), { ssr: false });
const CampaignQualificationNotificationListener = dynamic(
  () =>
    import('@ping/components/CampaignQualification/CampaignQualificationNotificationListener').then(
      module => module.CampaignQualificationNotificationListener
    ),
  { ssr: false }
);
const CampaignDrawReminderNotificationListener = dynamic(
  () =>
    import('@ping/components/CampaignDrawReminder/CampaignDrawReminderNotificationListener').then(
      module => module.CampaignDrawReminderNotificationListener
    ),
  { ssr: false }
);
const CampaignRewardReadyNotificationListener = dynamic(
  () =>
    import('@ping/components/CampaignRewardReady/CampaignRewardReadyNotificationListener').then(
      module => module.CampaignRewardReadyNotificationListener
    ),
  { ssr: false }
);
const RevenueAdminNotificationListener = dynamic(
  () =>
    import('@ping/components/RevenueAdminNotification/RevenueAdminNotificationListener').then(
      module => module.RevenueAdminNotificationListener
    ),
  { ssr: false }
);
const TreasuryAdminNotificationListener = dynamic(
  () =>
    import('@ping/components/TreasuryAdminNotification/TreasuryAdminNotificationListener').then(
      module => module.TreasuryAdminNotificationListener
    ),
  { ssr: false }
);

import type { IReactQueryProviderProps } from './ReactQueryProvider';
import dynamic from 'next/dynamic';
import { ErrorBoundary } from './ErrorBoundary';

export interface IProvidersProps extends IReactQueryProviderProps {
  children: React.ReactNode;
}

const Providers = ({ children, dehydratedState }: IProvidersProps) => (
  <ErrorBoundary>
    <ReactQueryProvider dehydratedState={dehydratedState}>
      <NextQueryParamProvider>
        <ReactAriaOverlayProvider>
          <ModalProvider>
            <CampaignQualificationNotificationListener />
            <CampaignDrawReminderNotificationListener />
            <CampaignRewardReadyNotificationListener />
            <RevenueAdminNotificationListener />
            <TreasuryAdminNotificationListener />
            {children}
          </ModalProvider>
        </ReactAriaOverlayProvider>
      </NextQueryParamProvider>
    </ReactQueryProvider>
  </ErrorBoundary>
);

export default Providers;
